import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchArtistById } from '../api/artists';
import LoadingSpinner from '../components/LoadingSpinner';
import { teamNameTranslator } from '../helpers/teamHelpers';

const ArtistDetailPage = () => {
    const { artistID } = useParams();
    const [artist, setArtist] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const fetchedArtist = await fetchArtistById(artistID);
                if (!cancelled) setArtist(fetchedArtist);
            } catch (err) {
                if (!cancelled) {
                    setError(err.message);
                    toast.error('Error fetching artist: ' + err.message);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [artistID]);

    if (loading) return <LoadingSpinner />;
    if (error || !artist) {
        return (
            <div className="container">
                <Link to="/artists" className="paragraph">← All artists</Link>
                <p className="paragraph">Artist not found.</p>
            </div>
        );
    }

    const cards = (artist.Cards ?? []).toSorted((first, second) => (second.rating || 0) - (first.rating || 0));

    return (
        <div className="container artist-detail">
            <Link to="/artists" className="artist-back-link">← All artists</Link>
            <h1 className="header">{artist.name || 'Unknown artist'}</h1>
            {artist.description ? <p className="artist-description">{artist.description}</p> : null}
            {artist.url ? (
                <p className="artist-url">
                    <a href={artist.url} target="_blank" rel="noopener noreferrer">{artist.url}</a>
                </p>
            ) : null}

            <h2 className="subheader">Cards ({cards.length})</h2>
            {cards.length === 0 ? (
                <p className="paragraph">No cards for this artist yet.</p>
            ) : (
                <div className="table-scroll-wrapper">
                    <table className="artist-cards-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Year</th>
                                <th>Team</th>
                                <th>Positions</th>
                                <th>Rating</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cards.map(card => (
                                <tr key={card.cardID}>
                                    <td>{card.name}</td>
                                    <td>{card.year}</td>
                                    <td>{card.teamNameID ? teamNameTranslator(card.teamNameID) : '—'}</td>
                                    <td>{card.positions || '—'}</td>
                                    <td>{card.rating}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ArtistDetailPage;
